import React from 'react'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import img1 from '../../images/public/asset1.svg'
import img2 from '../../images/public/asset2.svg'
import img3 from '../../images/public/asset3.svg'
import img4 from '../../images/public/asset4.svg'
import img5 from '../../images/public/asset5.svg'
import img6 from '../../images/public/asset6.svg'
import img7 from '../../images/public/asset7.svg'
import img8 from '../../images/public/asset8.svg'

class HowItWorks extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<main>
	      <section className="homepage-feature">
	        <Header isNavbarFixed={true} />
	        <div className="homepage-feature--image howitworks">
	          <div className="container">
	            <div className="jumbotron">
	              <div className="row">
	                <div className="col-md-8 col-sm-12 col-xs-12">
										<div className="flex vertical-item--between">
	                    <div className="flex-1">
												<h2 className="section-heading m-t-0">How Astronaut Works </h2>
			                  <p>With the your Astronaut account you can create simple, fast and effective Q&A sessions for your candidates. What’s a Q&A sessions you ask? It’s a blend of questions to be answered by video-selfie plus some by multiple-choice. Keep the sessions short, sharp and respect your candidate’s time. They can answer anywhere with our iOS, Android mobile apps. You’ll achieve engagement levels like never before, avoid phone screening and avoid the need to make poor screening decisions based on CV. See below for details.</p>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
				<section className="m-t-24">
	        <div className="container">
	          <div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6 col-sm-push-6">
                  <img className="media-object img-responsive center" src={img1} alt="" />
	              </div>
	              <div className="col-sm-6 col-sm-pull-6">
	                <div className="media-body text-left">
	                  <h4 className="media-heading heading1">Assessment, plus video</h4>
	                  <p>With our multi-choice question format you can create tests for anything! We’ve been called “SurveyMonkey on steroids” which we feel is not far from the truth. Power-up!</p>
	                </div>
	              </div>
	            </div>
	          </div>
	          <div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6">
                  <img className="media-object img-responsive" src={img2} alt="" />
	              </div>
	              <div className="col-sm-6">
	                <div className="media-body text-right">
	                  <h4 className="media-heading heading1">Our assessment partners</h4>
	                  <p>We love to partner with assessment providers. Ask us to work with your assessment partner to combine their methodologies within our candidate experience. It’s a super win-win-win-win for you, them, us and the candidates. </p>
	                </div>
	              </div>
	            </div>
	          </div>
	          <div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6 col-sm-push-6">
                  <img className="media-object img-responsive" src={img3} alt="" />
	              </div>
	              <div className="col-sm-6 col-sm-pull-6">
	                <div className="media-body text-left">
	                  <h4 className="media-heading heading1">See, hear & assess with video </h4>
	                  <p>With video answers it’s like the candidate is inside your account. Ask them the right questions and you’ll get very useful data with which to shortlist. See how they react to you difficult, testing and exploratory questions. You can even watch their videos answers while at the gym, or wherever really. </p>
	                </div>
	              </div>
	            </div>
	          </div>
						<div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6">
                  <img className="media-object img-responsive" src={img4} alt="" />
	              </div>
	              <div className="col-sm-6">
	                <div className="media-body text-right">
	                  <h4 className="media-heading heading1">Question library </h4>
	                  <p>Be prepared, and plan for success. Bring consistency and structure to your team by pre-populating your question library (including interview templates) with the input from your hiring managers. What are their favourite interview questions? </p>
	                </div>
	              </div>
	            </div>
	          </div>
						<div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6 col-sm-push-6">
                  <img className="media-object img-responsive center" src={img5} alt="" />
	              </div>
	              <div className="col-sm-6 col-sm-pull-6">
	                <div className="media-body text-left">
	                  <h4 className="media-heading heading1">Customise for your target segments </h4>
	                  <p>Having a clear and inviting employer brand has never been more important. With our job video tool, embedded into our job landing pages (can easily be white-labelled), tell your story with video and highlight what’s really important for your candidates to know. Contact us for more information.</p>
	                </div>
	              </div>
	            </div>
	          </div>
	          <div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6">
                  <img className="media-object img-responsive" src={img6} alt="" />
	              </div>
	              <div className="col-sm-6">
	                <div className="media-body text-right">
	                  <h4 className="media-heading heading1">Hiring team collaboration </h4>
	                  <p>Getting fast buy-in from all the key decision-makers is possible by adding them to the hiring team. They’ll get the alerts you set for them, and you’ll get the confidence to spend your valuable time with the right candidates.</p>
	                </div>
	              </div>
	            </div>
	          </div>
	          <div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6 col-sm-push-6">
                  <img className="media-object img-responsive" src={img7} alt="" />
	              </div>
	              <div className="col-sm-6 col-sm-pull-6">
	                <div className="media-body text-left">
	                  <h4 className="media-heading heading1">Talent pooling </h4>
	                  <p>With rapid evolution in the need for agile teams, it’s never been more important to have talent at your fingertips. By using Astronaut you’ll have a deeper understanding of all the candidates in your database so you can plan, and build your agile teams fast. This is also of huge benefit to our partners in the agency world. </p>
	                </div>
	              </div>
	            </div>
	          </div>
						<div className="media-showcase">
	            <div className="row">
	              <div className="col-sm-6">
                  <img className="media-object img-responsive" src={img8} alt="" />
	              </div>
	              <div className="col-sm-6">
	                <div className="media-body text-right">
	                  <h4 className="media-heading heading1">Your partner in agile innovation</h4>
	                  <p>Underlying all of this is an attitude of co-creation in partnership. Many of our existing features were direct requests from our most valued users. We like demanding clients who are always seeking to push themselves (and us) to greater levels of value creation. Are you in this category? Do you want to be? We’re ready for you. </p>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<div className="section-divider"></div>
						</div>
					</div>
				</div>
	      <SupportList />
				<CallToActRegister />
				<Footer />
			</main>
		)
  }
}

export default HowItWorks
